export function setupShelfMarquee (track, { durationSeconds = 30, reducedMotion = false } = {}) {
  if (!track) return

  if (reducedMotion) {
    track.classList.add('shelf-marquee-track--static')
    return
  }

  if (!track.dataset.marqueeDuplicated) {
    const items = [...track.children]
    items.forEach((item) => {
      const clone = item.cloneNode(true)
      clone.setAttribute('aria-hidden', 'true')
      clone.querySelectorAll('a, button').forEach((el) => {
        el.setAttribute('tabindex', '-1')
      })
      track.appendChild(clone)
    })
    track.dataset.marqueeDuplicated = 'true'
  }

  const seconds = Math.max(12, Math.min(120, durationSeconds))
  track.style.setProperty('--shelf-marquee-duration', `${seconds}s`)
  track.classList.add('shelf-marquee-track--animate')
}

export function pauseShelfMarquee (track) {
  track?.classList.add('is-paused')
}

export function resumeShelfMarquee (track) {
  track?.classList.remove('is-paused')
}

export function prefersReducedMotion () {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}
